import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import HotSauceLogo from './components/HotSauceLogo';
import Character from './components/Character';
import Profile from './components/Profile';

function App() {
  const [isMobile, setIsMobile] = useState(() => {
    return window.innerWidth <= 1024 || 
           /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  });

  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 1024 || 
                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const characters = [
    {
      name: '김선응',
      image: '/김선응누끼.png',
      position: 'left',
      sns: 'https://www.instagram.com/apnalchangchangkimseoneung/'
    },
    {
      name: '송형주',
      image: '/송형주누끼.png',
      position: 'right',
      sns: 'https://www.instagram.com/hyoja94/?hl=ko'
    },
    {
      name: '황해성',
      image: '/황해성누끼.png',
      position: 'bottom',
      sns: 'https://instagram.com/hhhhsss214?utm_medium=copy_link'
    },
    {
      name: '배건우',
      image: '/배건우누끼2.png',
      position: 'top',
      sns: 'https://www.instagram.com/baebae_geonwoo'
    }
  ];

  const cornerCharacters = characters.filter((character) => character.position !== 'top');
  const centerCharacter = characters.find((character) => character.position === 'top');

  const members = [
    {
      koreanName: '김선응',
      englishName: 'Kim Seon-eung',
      nickname: '앞창',
      birth: '1994년 7월 11일',
      physical: '178.2cm, 82kg',
      mbti: 'ENFP',
      bloodType: 'O형',
      profileImage: '/김선응프로필.webp'
    },
    {
      koreanName: '송형주',
      englishName: 'Song Hyeong-ju',
      nickname: '효자',
      birth: '1994년 4월 17일',
      physical: '187cm, 88kg',
      mbti: 'ENTJ',
      bloodType: 'O형',
      profileImage: '/송형주프로필.webp'
    },
    {
      koreanName: '배건우',
      englishName: 'Bae Geon-woo',
      nickname: '배말랭',
      birth: '1996년 1월 4일',
      physical: '172cm, 72.4kg',
      mbti: 'ENFJ',
      bloodType: '모름',
      profileImage: '/배건우프로필.webp'
    },
    {
      koreanName: '황해성',
      englishName: 'Hwang Hae-seong',
      nickname: '황룡갑',
      birth: '1996년 2월 14일',
      physical: '174cm, 73kg',
      mbti: 'ENFP',
      bloodType: 'A형',
      profileImage: '/황해성프로필.webp'
    }
  ];

  return (
    <div className="App">
      <Navigation />
      {/* 첫 번째 페이지 - 홈 */}
      <section id="home" className="page page-1">
        {!isMobile && (
          <div className="landing-stage desktop-only">
            {cornerCharacters.map((character) => (
              <Character
                key={character.name}
                name={character.name}
                image={character.image}
                position={character.position}
                sns={character.sns}
              />
            ))}
            <div className="landing-center">
              {centerCharacter && (
                <Character
                  key={centerCharacter.name}
                  name={centerCharacter.name}
                  image={centerCharacter.image}
                  position={centerCharacter.position}
                  sns={centerCharacter.sns}
                />
              )}
              <HotSauceLogo />
            </div>
          </div>
        )}
        {isMobile && (
          <div className="mobile-info">
            <div className="mobile-logo-wrapper">
              <HotSauceLogo />
            </div>
            <p className="mobile-message fade-away">
              이 페이지는 PC 환경에 최적화되어 있습니다.<br />
              더 나은 경험을 위해 PC에서 방문해 주세요.
            </p>
          </div>
        )}
      </section>
      
      {/* 두 번째 페이지 - 멤버 */}
      {!isMobile && (
        <section id="members" className="page page-2">
          <div className="page-content">
            <div className="profiles-container">
              {members.map((member) => (
                <Profile key={member.koreanName} member={member} />
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default App;
